class WeddingDetailsForm extends HTMLElement {
  connectedCallback() {
    this.fields = [...this.querySelectorAll("[data-attribute-field]")];

    this.fields.forEach((field) => {
      const eventName = field.type === "checkbox" || field.type === "radio" ? "change" : "blur";

      field.addEventListener(eventName, () => {
        if (field.name === "attributes[Wedding Date]" && field.value) {
          const dateField = field.closest("date-field");

          if (dateField && !dateField.isValidDate(field.value)) {
            clearTimeout(this._saveTimer);
            return;
          }
        }

        this._queueSave();
      });
    });

    this._initUnknownDateToggle();
  }

  disconnectedCallback() {
    clearTimeout(this._saveTimer);
  }

  _initUnknownDateToggle() {
    const checkbox = this.querySelector('[name="attributes[Wedding Date Unknown]"]');
    const dateInput = this.querySelector('[name="attributes[Wedding Date]"]');

    if (!checkbox || !dateInput) return;

    const dateField = dateInput.closest("date-field");

    const sync = () => {
      dateField?.setDisabled(checkbox.checked);

      if (checkbox.checked && dateInput.value) {
        dateInput.value = "";
        dateInput.dispatchEvent(new Event("input", { bubbles: true }));
        dateInput.dispatchEvent(new Event("blur", { bubbles: true }));
      }
    };

    checkbox.addEventListener("change", sync);
    sync();
  }

  _queueSave() {
    clearTimeout(this._saveTimer);
    this._saveTimer = setTimeout(() => this._save(), 300);
  }

  _save() {
    const attributes = {};

    this.fields.forEach((field) => {
      const match = field.name.match(/^attributes\[(.+)\]$/);

      if (!match) return;

      const key = match[1];

      if (field.type === "checkbox") {
        attributes[key] = field.checked ? field.value : "";
      } else if (field.type === "radio") {
        if (field.checked) attributes[key] = field.value;
      } else {
        attributes[key] = field.value;
      }
    });

    window.updateCartAttributes(attributes);
  }
}

if (!customElements.get("wedding-details-form")) {
  customElements.define("wedding-details-form", WeddingDetailsForm);
}
